<div class="container h-100">
    <div class="row justify-content-center">
        <div class="m-auto">
            <h1 class="header text-center">404</h1>
            <p class="text text-center">The page you are looking for doesn't exist.</p>
        </div>
    </div>
</div>